const MUMBAI = {
    chainId: "0x13881",
    chainName: "Mumbai",
    rpcUrls: ["https://rpc-mumbai.maticvigil.com/"],
    nativeCurrency: {
        name: "Matic",
        symbol: "MATIC",
        decimals: 18,
    },
    blockExplorerUrls: ["https://mumbai.polygonscan.com"],
}

export { MUMBAI };